import { render } from "./MailFrom.vue?vue&type=template&id=4a42d201&scoped=true"
import script from "./MailFrom.vue?vue&type=script&lang=js"
export * from "./MailFrom.vue?vue&type=script&lang=js"

import "./MailFrom.vue?vue&type=style&index=0&id=4a42d201&scoped=true&lang=css"

import exportComponent from "/Users/admin/Downloads/project_output 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a42d201"]])

export default __exports__